import * as Oazapfts from "oazapfts/lib/runtime";
import useHaiiExAuth from "src/composables/server/useHaiiExAuth";
import { computed } from "vue";

type serverType = "strokcare" | "admin";

export default function useServer(apiSet: serverType) {
  const baseUrl = computed(() => {
    if (apiSet == "admin") {
      return process.env.VUE_APP_ADMIN_SERVER_URL;
    }
    return process.env.VUE_APP_STROKCARE_SERVER_URL;
  });

  const requestOptions = computed((): Oazapfts.RequestOpts => {
    return {
      baseUrl: baseUrl.value,
    };
  });

  async function manageToken() {
    const { manageToken } = useHaiiExAuth();
    await manageToken(true);
  }

  return {
    baseUrl,
    requestOptions,
    manageToken,
  };
}
